__turbopack_context__.v({
  "root": "PlasmicTableTd-module__dKKx0G__root",
  "text___5NnZu": "PlasmicTableTd-module__dKKx0G__text___5NnZu",
});
